import controller from './package-churn-retention-success-dialog.controller';

export default {
  controller,
  template: require('./package-churn-retention-success-dialog.html')
};
require('./package-churn-retention-success-dialog.less');


// WEBPACK FOOTER //
// src/app/packet/package-churn-retention-success-dialog/package-churn-retention-success-dialog.component.ts